import ApiService from "service/Api";
import { RewardShipmentPayloadTypes } from "utilities/types/RewardShipment";
import { RewardShipmentDetailPayloadTypes } from "utilities/types/RewardShipmentDetail";

const RewardShipmentService = {
  getAllRewardShipments: async (
    page: number,
    search: string,
    limit: number,
    filterTenant: number
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        is_voucher: 0,
        search: search,
        page: page,
        per_page: limit,
        filter_tenant: filterTenant,
      },
      url: "/admin/catalog-shipments",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getRewardShipmentById: async (catalogShipmentId: string) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "admin/catalog-shipments/" + catalogShipmentId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateRewardShipment: async (
    rewardShipmentId: string,
    payload: RewardShipmentPayloadTypes
  ) => {
    const { trackingNumber, service, trackingLink } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        tracking_number: trackingNumber,
        service: service,
        tracking_link: trackingLink,
        _method: "PUT",
      },
      url: "/admin/catalog-shipments/" + rewardShipmentId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeRewardShipmentDetail: async (
    rewardShipmentId: string,
    payload: RewardShipmentDetailPayloadTypes
  ) => {
    const { description, subDescription } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        description: description,
        sub_description: subDescription,
      },
      url: "/admin/catalog-shipments/" + rewardShipmentId + "/details",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default RewardShipmentService;
